<template>
	<ss-activity-detail :showRecmd="false" />
</template>

<script>
	import ssActivityDetail from '@/components/ss-activity-detail/ss-activity-detail.vue'
	export default {
		name: 'culturalInfoDetail',
		components: {
			ssActivityDetail
		}
	}
</script>

<style type="scss">
	.ss-container__left{
		margin-left: 55px;
	}
</style>
